// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
require('./form.scss');

const deps = [
  require('angular-ui-router'),
  require('ui/web/modal').name,
  require('./new').name,
  require('./ledger').name,
  require('./addon').name,
];

module.exports = angular
  .module('bench.app.mainapp.details.overview.form', deps)

  .config($stateProvider =>
    $stateProvider.state('bench.details.overview.form', {
      abstract: true,
      url: '',
      onEnter($state, $stateParams, ngDialog) {
        return ngDialog
          .open({
            appendTo: '[ng-app]',
            template: `\
<div class="form-card">
  <div
    class="bl-card_section bl-card_section-padded-medium form-card_header">
    <a ui-sref="^.^" class="bl-icon-close form-card_close"></a>
  </div>
  <div ui-view="modal"/>
</div>\
`,
          })
          .closePromise.then(() => $state.go('bench.details.overview'));
      },
      onExit(ngDialog) {
        return ngDialog.closeAll();
      },
    }),
  );
